export default __webpack_public_path__ + "static/media/Vantagens_IMG.7234aa84.png";